import React, { Component } from 'react';

// Third Party
import Marquee from "react-fast-marquee";


// Custom Components
import Header from '../components/Header'
import CourseItem from '../components/CourseItem'
import Hero from '../components/Hero'
import ProjectCard from '../components/ProjectCard'
import SingleAppShowCase from '../components/SingleAppShowcase'


// Hero Image
import moState from '../img/optimized/moState.jpeg'

// Images
import globe from '../img/globe.svg'
import brain from '../img/brain.svg'
import cpu from '../img/cpu.svg'
import math from '../img/function.svg'
import game from '../img/chess.svg'
import graph from '../img/graph.svg'
import database from '../img/database.svg'
import ram from '../img/ram.svg'
import html from '../img/html.svg'
import lock from  '../img/lock.svg'
import badge from '../img/badge.svg'
import scrum from '../img/scrum.svg'
import check from '../img/check.svg'
import image from '../img/image.svg'
import seminar from '../img/seminar.svg'
import mobile from '../img/mobile.svg'
import brackets from '../img/brackets.svg'

import emotion from '../img/optimized/emotion_detection.png'




class School extends Component {
   constructor(props) {
    super(props);
    this.state = {
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
    <div 
    className={"msu-background"}
    style={{
        overflowX: 'hidden',
        backgroundColor: "#630A13"
    }}>
        <Header
            title="Missouri State"
            backgroundColor={'#FFF'}
            textColor={'maroon'}
            jobTitle={'Computer Science Student'}
            yearsAtRole={"2017-2021"}
        /> 
        <Hero
            heroBackground={moState}
            jobTitle={"Computer Science Student"}
            companyName={"Missouri State University"}
            yearsActive={"2017 - 2021"}
        />

        <SingleAppShowCase
          backgroundColor={'#630A13'}
          appTitle={"Capstone: Emotion Detection from Short Voice Clip"}
          logoWidth={"50%"}
          addClass={"msu-background"}
          extraPadding={'15%'}
          lightText={true}
          appDescription="An Electron application that applies Python Audio Processing and Machine Learning to accurately predict the emotion of the user with just a 5 second audio clip."
          appVisual={emotion}
          url="https://github.com/DaltonWemer/emotion-detection-system?tab=readme-ov-file"
        /> 
        <h2 class="msu-heading">Favorite Projects</h2>

        <div 
            className="msu-project-grid"
        >
            <div class="project-row">
                <ProjectCard
                    title={"Connected Components in Graph"}
                    courseName={"Algorithms and Advanced Data Structures"}
                    language={"cpp"}
                    github={"https://github.com/DaltonWemer/connected-components"}
                    description={"This program uses disjoint set operations to determine the number of connected components in a graph that is represented by an adjacency matrix (n x n). The program also shows all nodes that are present in each of the connected components. A connected component in a directed graph G = (E, V) is a subgraph in which two verticies are connected to each other by paths but are connected to no other vertices in the graph."}
                />
                <ProjectCard
                    title={"Implementation of Red and Black Tree"}
                    courseName={"Data Structures"}
                    language={"cpp"}
                    github={"https://github.com/DaltonWemer/red-black-tree"}
                    description={"A red–black tree is a self-balancing binary search tree. Each node of the binary tree has an extra bit, and that bit is often interpreted as the color (red or black) of the node. These color bits are used to ensure the tree remains approximately balanced during insertions and deletions. Most operations on a Red Black Tree can be completed in O(log n)."}
                />
            </div>
            <div class="project-row">
                <ProjectCard
                    title={"Bankers Algorithm Simulation"}
                    courseName={"Operating Systems"}
                    language={"python"}
                    github={"https://github.com/DaltonWemer/bankers-algorithm"}
                    description={"The banker's algorithm is designed for both resource allocation and deadlock avoidance. It tests the safety of a system by simulating the system's state if the requested resources were allocated to a process. If the system is capable of fulfilling the request safely, the proper resources will be allocated. If not, the request will be denied. This process is similar to the process a bank would go through if they were looking to evaluate the approval of a loan, a bank would not allocate its money in a way that would prevent them from taking care of the rest of its customers. My program is a simulation of this core algorithm in any operating system."}
                />
                <ProjectCard
                    title={"Page Replacement Algorithms"}
                    courseName={"Operating Systems"}
                    language={"cpp"}
                    github={"https://github.com/DaltonWemer/page-replacement-algorithm"}
                    description={"This program is a simulation of a few of the most popular page replacement algorithms: FIFO (First In, First Out), LRU (Least Recently Used), Random and, Optimal. These are all different approaches to solve the same problem and measuring how each of thsese might perform in a real world example in operating systems is what this program aims to do. An operating system uses paging for memory managment. Page replacement algorithm determines when a page needs to be repalced with a new page coming in.  "}
                    
                />
            </div>

            <div class="project-row">
                <ProjectCard
                    title={"Noise Reduction on Images"}
                    courseName={"Computer Speech, Music, and Images"}
                    language={"processing"}
                    github={"https://github.com/DaltonWemer/noise-reduction-processing"}
                    description={"This program uses processing to reduce noise from images. This program is hardcoded to clean up the image using an reigon size of 3. It uses neighborhood processing to loop through a 3 x 3 matrix around every pixel and average out the color of each of the pixels. This program does not use a dynamic matrix but does have pretty decent results at removing static from images"}
                    
                />
                <ProjectCard
                    title={"Floyd-Steinberg Algorithm"}
                    courseName={"Computer Speech, Music, and Images"}
                    language={"processing"}
                    github={'https://github.com/DaltonWemer/floyd-steinberg-processing'}
                    description={"The Floyd-Steinberg Algorithm is an image dithering algorithm that is commonly used when compressing images such as GIFs as GIFs have a restricted color pallete. It can be used to lower the size of images by compressing the range of colors. This program simulates indexed color. It loads a color palette calculated using the k-means algorithm. These colors are substituted for the original pixel colors in the image."}
                    
                />
            </div>
            <div class="project-row">
                <ProjectCard
                    title={"Binary Addition Calculator"}
                    courseName={"Algorithms and Advanced Data Structures"}
                    language={"cpp"}
                    github={'https://github.com/DaltonWemer/binary-addition'}
                    description={"Simple C++ program that takes two binary numbers of n characters length and returns the sum. It has validation, so if a user inputs any data that is not a binary number, the program will return an error."}
                />
            </div>
        </div>

        <h2 className="msu-heading">Courses</h2>
        <Marquee 
            pauseOnHover={true}
            gradient={false}
            className="course-grid"
            style={{paddingLeft: '5%',width: '100%',}}
        >
        <CourseItem
            department="CSC"
            number="130"
            name="World of Computer Science"
            semester="Fall 2018"
            icon={globe}
            description="An introduction to programming and computer science. Topics include data representation, algorithm design, and software development."
            LanguagesUsed={["Python"]}
        />
        <CourseItem
            department="CSC"
            number="131"
            name="Computational Thinking"
            semester="Spring 2019"
            icon={brain}
            description={"Solving problems using computation and implementing solutions in a high-level programming language with emphasis on higher order functions, recursion, object-oriented programming and GUI development."}
            LanguagesUsed={["Python", "C++"]}
        />
        <CourseItem
            department="CSC"
            number="232"
            name="Data Structures"
            semester="Summer 2020"
            icon={brackets}
            description={"Topics include: algorithm design; complexity analysis; abstract data types and encapsulation; basic data structures and their application, including stacks, queues, linked lists and binary trees; dynamic memory allocation; recursion; sorting and searching; debugging techniques."}
            LanguagesUsed={["C++"]}
        />
        <CourseItem
            department="CSC"
            number="244"
            name="Computer Architecture"
            semester="Fall 2020"
            icon={cpu}
            description={"General topics include digital logic circuits, data representation, processor design, pipelining, vector processing, and memory organization."}
            LanguagesUsed={["MIPS"]}
        />
        <CourseItem
            department="MTH"
            number="314"
            name="Discrete Mathematics"
            semester="Fall 2020"
            icon={math}
            description={"Topics include: logic, mathematical reasoning, basic counting, discrete probability, matrices, recursion, sets and relations, graphs and trees."}
            LanguagesUsed={["Math"]}
        />
        <CourseItem
            department="ECO"
            number="314"
            name="Game Theory"
            semester="Fall 2021"
            icon={game}
            description={"This course serves as an introduction to game theory, the study of strategy. The field has applications in economics, business, military strategy, political science, sports, biology, and poker. Possible topics include games vs. decisions, dominance, Nash equilibrium, and others."}
            LanguagesUsed={["Math"]}
        />
        <CourseItem
            department="CSC"
            number="325"
            name="Algorithms and Advanced Data Structures"
            semester="Spring 2021"
            icon={graph}
            description={"A study of algorithms and advanced data structures including graphs, heaps, hashing, self-adjusting data structures, set representations, greedy algorithms, dynamic programming and introduction to NP-complete problems."}
            LanguagesUsed={["C++"]}
        />
        <CourseItem
            department="CSC"
            number="335"
            name="Database System Concepts"
            semester="Spring 2020"
            icon={database}
            description={"Core topics include the relational model, SQL, database design theory, query processing, file structures, transactions, and concurrency. Programming projects provide practical experience"}
            LanguagesUsed={["SQL"]}
        />
        <CourseItem
            department="CSC"
            number="360"
            name="Operating Systems"
            semester="Fall 2020"
            icon={ram}
            description={"Introduction to operating systems concepts, principles, and design. Topics include: processes, threads, CPU scheduling, mutual exclusion, process synchronization, deadlocks, memory management, file systems, i/o systems, disk management, distributed systems, security and protection. "}
            LanguagesUsed={["C", "C++", "Python"]}
        />
         <CourseItem
            department="CSC"
            number="365"
            name="Internet Programing"
            semester="Spring 2020"
            icon={html}
            description={"An introduction to paradigms and languages used in internet and World Wide Web programming. These include modern tools for client-side and server-side programming and dynamic Web page generation. Advanced topics, such as security and XML, will be covered as time allows. "}
            LanguagesUsed={["Javascript", "Java"]}
        />
        <CourseItem
            department="CSC"
            number="388"
            name="Introduction to Secure Computing"
            semester="Fall 2020"
            icon={lock}
            description={"Topics include: common threat types and cyber attacks including malware, denial-of-service, spoofing, and phishing as well as fundamental building blocks of secure computing systems such as authentication, encryption, and digital signatures."}
            LanguagesUsed={["SQL"]}
        />
        <CourseItem
            department="CSC"
            number="399"
            name="Cooperative Education in Computer Science"
            semester="Summer 2020"
            icon={badge}
            description={"The opportunity to earn academic credit in a planned learning process that integrates academic training with a supervised work experience."}
            LanguagesUsed={["Javascript", "Swift", "Java", "PHP"]}
        />
        <CourseItem
            department="CSC"
            number="450"
            name="Introduction to Software Engineering"
            semester="Fall 2021"
            icon={scrum}
            description={"Focus on the software engineering concepts: requirements gathering and analysis, software architecture and design. Students will apply agile/scrum methodologies in a capstone project."}
            LanguagesUsed={["Javascript"]}
        />
        <CourseItem
            department="CSC"
            number="455"
            name="Software Quality Assurance"
            semester="Fall 2020"
            icon={check}
            description={"Topics including quality assurance, software validation and verification, various testing techniques. Other topics are essential software project planning steps, cost estimation, productivity metrics, release and configuration management concepts."}
            LanguagesUsed={["Python", "C++"]}
        />
        <CourseItem
            department="CSC"
            number="482"
            name="Seminar in Computer Science"
            semester="Fall 2020"
            icon={seminar}
            description={"This course focuses on professional development skills, including resume development, interviewing, and presentations. Case studies in ethics and steps for ethical decision making will be introduced. "}
            LanguagesUsed={["Python"]}
        />
        <CourseItem
            department="CSC"
            number="545"
            name="Computer Speech, Music, and Images"
            semester="Spring 2021"
            icon={image}
            description={"Topics include multimedia data capture and representation, methods of data compression, multimedia information retrieval, and multimedia standards."}
            LanguagesUsed={["Proccessing"]}
        />
         <CourseItem
            department="CSC"
            number="567"
            name="Mobile Computing Applications"
            semester="Spring 2021"
            icon={mobile}
            description={"Course topics will include design and creation of basic and advanced applications, use of an integrated development environment, performance and security issues, and application packaging and distribution mechanisms."}
            LanguagesUsed={["Java"]}
        />
        </Marquee>
    </div>
    );
  }
}

export default School;



// WEBPACK FOOTER //
// ./src/screens/School.js